export default __webpack_public_path__ + "static/media/premium_normal-available_loan-mobile.08601887.jpg";